import about from "../../assets/images/about.png";
import "./AboutMe.css";

const AboutMe = () => {
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="4000"
      className="my-5 container"
      id="about"
    >
      <h1 className="text-center fw-bold text-uppercase">About Me</h1>
      <div className="row d-flex align-items-center">
        <div className="col-lg-6">
          <img src={about} className="img-fluid w-100" alt="..." />
        </div>
        <div className="col-lg-6">
          <p>
            I'm Ahmad Subaktagin Jabir. I graduated from{" "}
            <b>Ahsanullah University of Science and Technology</b> and my major
            discipline was <b>Computer Science and Engineering</b>. Currently, I
            am working as a <b>Trainee Officer</b> in the{" "}
            <b>IT & eBiz department</b> of <b>AB Bank</b>. Besides that, I am
            pursuing <b>Masters of Business Administration (MBA)</b> degree at
            the <b>Bangladesh University of Professionals</b>. I have a
            particular passion for Web Development, Programming, and Software
            Testing. Now I am looking for opportunities to incorporate my skills
            and training to help a company grow. I am looking forward to roles
            that will help me realize my potential by exploring the various
            aspects of the IT Field.
          </p>
        </div>
      </div>
      <h3 className="text-center">Education</h3>
      <div className="row">
        <div className="col-md-12">
          <div className="card bg-transparent border-0">
            <div className="card-body">
              <div id="content">
                <ul className="timeline">
                  <li className="event" data-date="2022 - Present">
                    <h3>Masters of Business Administration (MBA)</h3>
                    <p>Bangladesh University of Professionals (BUP)</p>
                  </li>
                  <li className="event" data-date="2016 - 2021">
                    <h3>
                      Bachelor of Science (BSc.) in Computer Science and
                      Engineering
                    </h3>
                    <p>Ahsanullah University of Science and Technology</p>
                  </li>
                  <li className="event" data-date="2016">
                    <h3>Higher Secondary Certificate (HSC)</h3>
                    <p>Birshreshtha Noor Mohammad Public College</p>
                  </li>
                  <li className="event" data-date="2014">
                    <h3>Secondary School Certificate (SSC)</h3>
                    <p>Birshreshtha Noor Mohammad Public College</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
